<script>
    export let store;
</script>

<div class="flex flex-row my-2 text-md text-center space-x-1">
    <p>No Voucher?</p>
    <button
        class="text-blue-500 hover:text-blue-700"
        on:click={() => store.setState("BUNDLE_PURCHASE")}
    >
        Buy Voucher Now
    </button>
</div>
